<template>
  <div class="flex-vcenter">
    <h2>
      <slot name="titre">
        Informations
      </slot>
    </h2>
    <div
      v-if="$slots.details"
      class="details"
    >
      <slot name="details" />
    </div>
    <div class="tab-content">
      <slot name="content" />
    </div>
    <div
      v-if="$slots.buttons"
      class="buttons"
    >
      <slot name="buttons" />
    </div>
  </div>
</template>

<script>
export default {
  name: "ModalTab",
  emits: ["confirm"],
};
</script>